import { AuthorizationUsersMapping } from '@lovoldsystem/authorization.client'
import { IAuthUserInitialValues } from '@lovoldsystem/authorization.client/components/users/authorizationMapping.action'
import { useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { invalidateAccessGroups, useGetStorageUsers } from 'src/api/access-group'
import { permissionBinding, permissionLevel } from 'src/constant'
import { FacilityTypes, RoleTypes } from 'src/enums'
import { FunctionElementsParentsIds } from 'src/enums/auth'
import { useDialogCtx } from 'src/hooks/context-hooks'
import { getCustomerUsers } from 'src/http'

interface StoragesDetailPanelProps {
  storageId: number
  storageName: string
}

const StoragesDetailPanel = ({ storageId, storageName }: StoragesDetailPanelProps) => {
  const { showDialog, showConfirmDialog } = useDialogCtx()
  const { id } = useParams()
  const { t } = useTranslation('storage')
  const theme = useTheme()
  const { data } = useGetStorageUsers(id as EntityId, storageId)

  return (
    <AuthorizationUsersMapping
      title={t('storage-users')}
      showDialog={showDialog}
      height="200px"
      showConfirmDialog={showConfirmDialog}
      clientId={parseInt(id as string)}
      roleTypes={[RoleTypes.Storage]}
      permissionLevel={permissionLevel}
      initialValues={
        {
          facilityId: storageId as number,
          facilityName: storageName,
          type: FacilityTypes.storage,
          facilityTypeText: t('storage'),
        } as IAuthUserInitialValues
      }
      facilityUsers={data || []}
      invalidateUsers={() => {
        invalidateAccessGroups.getStorageUsers(id as EntityId, storageId)
      }}
      functionElementParents={[FunctionElementsParentsIds.StoragePortal]}
      permissionBinding={permissionBinding}
      useGetUsers={getCustomerUsers}
      theme={theme}
    />
  )
}

export default StoragesDetailPanel
